import * as EmojiMart from './index.js'
window.EmojiMart = EmojiMart
